import { isEqual } from 'lodash';
/*
columnsMap is of the form:

{
	[newHeader]: [originalHeader1, originalHeader2, ...]
}

*/

/* Private */

const DONT_MAP_SELECT_ITEM = { id: 'dont_map', value: 'dont_map', text: "Don't map" };
// const SEPARATOR_SELECT_ITEM = { id: 'separator' };
const MERGE_SELECT_ITEM = { id: 'merge', value: 'merge', text: 'Merge with' };
const SPLIT_SELECT_ITEM = { id: 'split', value: 'split', text: 'Split' };

const mapHeaders = (columnsMap) => {
	const result = [];
	for (const key of Object.keys(columnsMap)) {
		const mappedColumnsKeys = columnsMap[key];
		result.push({
			Target: key,
			Source: mappedColumnsKeys.join(', '),
		});
	}
	return result;
};
/* Public */

const getNewHeaderFromOriginal = (columnsMap, originalHeader) =>
	Object.keys(columnsMap).find((header) => columnsMap[header].includes(originalHeader));

const mapTable = (originalTable, columnsMap, isHeadersMappingMode) => {
	if (isHeadersMappingMode) {
		return mapHeaders(columnsMap);
	}
	const oldHeaders = Object.values(columnsMap).flat();
	const result = originalTable.map((rowToMap) => {
		const reducedColumn = {};
		oldHeaders.forEach((fromName) => {
			const toName = getNewHeaderFromOriginal(columnsMap, fromName);
			reducedColumn[toName] = reducedColumn[toName] ? `${reducedColumn[toName]}  ${rowToMap[fromName]}` : rowToMap[fromName];
		});
		return reducedColumn;
	});

	return result;
};

const getSelectedOptions = (columnsMap) => (columnsMap ? [...new Set(Object.keys(columnsMap))] : []).filter((o) => o !== 'dont_map');

const getNewMappedColumn = (columnsMap, newHeaderSelection, originHeadersToSet) => {
	const newColumnsMap = { ...columnsMap };
	originHeadersToSet.forEach((originHeaderToSet) => {
		const newHeaderToDelete = getNewHeaderFromOriginal(newColumnsMap, originHeaderToSet);
		if (newHeaderToDelete) {
			delete newColumnsMap[newHeaderToDelete];
		}
		if (newHeaderSelection !== DONT_MAP_SELECT_ITEM.value) {
			newColumnsMap[newHeaderSelection] = [...(newColumnsMap[newHeaderSelection] || []), originHeaderToSet];
		}
	});

	return newColumnsMap;
};

const hasMoreThanOneMapping = (columnsMap) => getSelectedOptions(columnsMap).length > 0;

const getColumnPreviewSample = (tableRows, columnNames) =>
	columnNames.length > 0
		? tableRows.map((row) => columnNames.reduce((result, current) => result + ' ' + row[current], '')).filter((row) => !!row)
		: '';

const reduceFromColumnMapping = (headerRowMapping, mergeMap) => {
	const allMergedHeaders = Object.values(mergeMap).flat();

	const newHeaderRowMapping = Object.keys(headerRowMapping)
		.filter((key) => !allMergedHeaders.includes(headerRowMapping[key]))
		.reduce((prev, currKey) => ({ ...prev, [currKey]: headerRowMapping[currKey] }), {});

	Object.keys(mergeMap).forEach((userSelectedSource) => {
		const originHeaderToMixInto = Object.keys(headerRowMapping).find((h) => headerRowMapping[h] === userSelectedSource);
		newHeaderRowMapping[originHeaderToMixInto] = mergeMap[userSelectedSource].join(' + ');
	});
	return newHeaderRowMapping;
};

const getFilteredRows = (rows, originalNewHeaderRow) => {
	const headerObjectIndexInTable = rows.findIndex((row) => isEqual(row, originalNewHeaderRow));

	return rows.slice(headerObjectIndexInTable + 1, rows.length);
};

const ColumnMapperService = {
	mapTable,
	getNewHeaderFromOriginal,
	getSelectedOptions,
	getNewMappedColumn,
	hasMoreThanOneMapping,
	getColumnPreviewSample,
	reduceFromColumnMapping,
	getFilteredRows,

	SPLIT_SELECT_ITEM,
	MERGE_SELECT_ITEM,
	DONT_MAP_SELECT_ITEM,
};

export default ColumnMapperService;
